<template>
<div>
<!-- Modal -->
<div class="modal " id="modalPricing" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-info text-white">
        
        <h4 class="modal-title" id="staticBackdropLabel">
          <i style="color:beige" class="fas fa-calculator mr-2" aria-hidden="true"></i>
          INSERIMENTO PREZZO DI ACQUISTO,SCONTO,IVA E PREZZO DI VENDITA PRODOTTO</h4>
        
      </div>
      <form v-on:submit.prevent="submit()">
      <div class="modal-body">

    <div class="form-row">

    <div class="form-group col-md-12">
      <label for="input1"><strong>Prezzo di acquisto</strong></label>
          <div class="input-group mb-2">
          <div class="input-group-prepend">
          <div class="input-group-text">€</div>
          </div>  
          <input required min="0.01" step="0.01" id="price1" class="form-control"   type="number" v-model="prices.price1" v-bind:placeholder="'Prezzo di acquisto'">      
          </div>
    </div>
    <div class="form-row col-12">
      <div class="form-group col-md-4">
        <label for="inputSconto1">Sconto1</label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text">%</div>
                </div>  
        <input step="0.01"  type="number" class="form-control" v-model="discounts.discount1" >
        </div>
      </div>
      <div class="form-group col-md-4">
        <label for="inputSconto2">Sconto2</label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text">%</div>
                </div>  
        <input step="0.01" type="number" class="form-control" v-model="discounts.discount2">      
        </div>
      </div>
      <div class="form-group col-md-4">
        <label for="inputSconto3">Sconto3</label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text">%</div>
                </div>  
        <input step="0.01"  type="number" class="form-control" v-model="discounts.discount3">
        </div>
      </div>
    </div>
    <div class="form-row col-12">
      <div class="form-group col-md-12">
        <label for="inputVat">Iva</label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text">%</div>
                </div>  
          <input required type="number" class="form-control" placeholder="" v-model="prices.vat">
        </div>
          </div> 
    </div>   
    <div class="form-row col-12">
      <div class="form-group col-md-3">
        
        <label  for="inlineFormInput2">Calcola Ricarico </label>
               <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text">%</div>
                </div>
              <input  type="number" class="form-control " id="mult" placeholder="" v-model="multiplier">
              <button type="button" :disabled="!prices.price1 || !multiplier" @click="setCalc()"  title="Calcola ricarico"  class="btn calc pointer" id="basic-addon1"><i class="fas fa-calculator" aria-hidden="true"></i></button>
              </div>
        
      </div> 
      <div class="form-group col-md-9">
        <label for="inputPrice2"><strong>Prezzo di vendita</strong></label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text">€</div>
                </div>  
                <input @input="setMarkUp()" required v-model="prices.price2" min="0.01" step="0.01" class="form-control"   type="number" v-bind:placeholder="'Prezzo di vendita'">   
                
        </div>
        
        
      </div> 
      <small><span style="font-size: 20px;" class="badge badge-light">Ricarico {{markUp}}</span></small>
     
    </div>   

</div>       
</div>

      <div class="modal-footer">
        <button @click="$emit('close')" type="button" class="btn btn-secondary mr-3" data-dismiss="modal">CHIUDI</button>
        <button  type="submit" class="btn btn-primary" >
          <i class="far fa-edit mr-3" aria-hidden="true"></i>     
          APPLICA</button>
      </div>
    </form>

    </div>
  </div>
</div>
    

</div> 
</template>

<script>

import alertBox         from '@/components/common/AlertBox.vue';
import { mapGetters }        from 'vuex';
export default {
  
  components: {alertBox},  
  props: ['props'],
 
  data () {
  
    return {

     prices     : {'price1':'','price2':''}, 
     discounts  : {},
     multiplier : '',
     markUp     : 0.00,

     msg     : {
       title : '',
       body  : '',
       type  : 0
     },
    

    }
  },
  computed: 
    {     
     ...mapGetters(['company']) 
      
    },
          
  mounted()
    {
    
      $('#modalPricing').on('shown.bs.modal', function () {
        $('#price1').trigger('focus')
      })
      
    },

  created()
  {
   
    
   this.multiplier    = JSON.parse(localStorage.getItem("mult"))
   this.prices.price1 = this.props.prices.price1
   this.prices.price2 = this.props.prices.price2
   this.prices.vat    = this.company.vat
   
   this.props.discounts.forEach(item => {
    if(item.order_by == 1)
    {
      this.discounts.discount1 = item.discount
    }
    if(item.order_by == 2)
    {
      this.discounts.discount2 = item.discount
    }
    if(item.order_by == 3)
    {
      this.discounts.discount3 = item.discount
    }
   })
   

   

  },

  methods: 
  {

    submit()
    {
      let discounts = []
      if(this.discounts.discount1)
      {
        discounts.push({'discount':this.discounts.discount1,'order_by':1})
      }
      if(this.discounts.discount2)
      {
        discounts.push({'discount':this.discounts.discount2,'order_by':2})
      }
      if(this.discounts.discount3)
      {
        discounts.push({'discount':this.discounts.discount3,'order_by':3})
      }
      this.$emit('update',this.prices,discounts)

    },
    getDiscountedPrice()
    {
      let total = 0.00
      total = this.prices.price1
        
      if(this.discounts.discount1)
      {
        total = total - (total / 100.00 * this.discounts.discount1 )  
      }
      if(this.discounts.discount2)
      {
        total = total - (total / 100.00 * this.discounts.discount2 )  
      }
      if(this.discounts.discount3)
      {
        total = total - (total / 100.00 * this.discounts.discount3 )  
      }
      return total
    },
    setCalc()
    {
    
      let total = this.getDiscountedPrice()
      let retailPrice = total * this.multiplier / 100.00 
        
      retailPrice = retailPrice +  Number(total)
    
      this.prices.price2 = retailPrice.toFixed(2) 

      localStorage.setItem('mult',JSON.stringify(this.multiplier))
      this.setMarkUp(total)
      
 },
 setMarkUp(price)
 {
  
  let price1 = !price ? this.getDiscountedPrice() : price
  
  this.markUp = 0
  if(Number(price1) > 0 && Number(this.prices.price2) > 0)
  {

    let n = Number(this.prices.price2) / Number(price1)
    this.markUp = n.toFixed(2)
  }
 }
        
}
  
}
</script>

<style scoped>
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}

.pointer{
  cursor: pointer;
}


h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
  
}



.calc{
  background-color:  #ffc107;;
}
</style>